import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { DMPLogo } from '../brand/DMPLogo';
import { BdFlag } from '../brand/BdFlag';
export function PresentationShell({
  title,
  subtitle,
  children
}: {
  title: string;
  subtitle: string;
  children: React.ReactNode;
}) {
  return <div className="min-h-screen w-full bg-[#F4F7FB]" data-id="element-594" data-mp="1hl26kg5skno8">
      <header className="bg-[#003B71] text-white" data-id="element-595" data-mp="kvukn719gcjs">
        <div className="mx-auto flex max-w-7xl items-center gap-4 px-6 py-4" data-id="element-596" data-mp="kx5mv2f25c8s">
          <DMPLogo size={52} data-id="element-597" data-mp="owo9q3qfvxe9" />
          <div className="flex-1" data-id="element-598" data-mp="oxz9ztkoen0m">
            <div className="text-xs text-white/70" data-id="element-599" data-mp="twiyo1qnmcwo">ঢাকা মেট্রোপলিটন পুলিশ • ট্রাফিক বিভাগ</div>
            <h1 className="text-xl font-bold md:text-2xl" data-id="element-600" data-mp="tuptyrzlq2rb">{title}</h1>
          </div>
          <BdFlag width={40} data-id="element-601" data-mp="ypc5qw9lhxbx" />
        </div>
        <div className="h-1 bg-[#006A4E]" data-id="element-602" data-mp="18ep354ypfop" />
      </header>
      <main className="mx-auto max-w-7xl px-6 py-8" data-id="element-603" data-mp="15shx6lzh270">
        <div className="mb-6 flex flex-wrap items-center justify-between gap-3" data-id="element-604" data-mp="65wrecoh4wnq">
          <p className="text-slate-600" data-id="element-605" data-mp="3laie9jrenfk9">{subtitle}</p>
          <Link to="/" className="inline-flex items-center gap-1 text-sm font-medium text-[#1769AA] hover:underline" data-id="element-606" data-mp="3lc39lbljn2j6"><ArrowLeft className="h-4 w-4" data-id="element-607" data-mp="3hahynvskkybm" /> প্রোটোটাইপ হাব</Link>
        </div>
        {children}
      </main>
    </div>;
}